// Shared by the API and the SSR frontend; keep this module free of Node-only imports.
const PAGE_SIZE = 12;
const parseNewsPage = (value) => {
    if (value === undefined || value === null || value === '') return 1;

    if (!/^[1-9]\d*$/.test(String(value)) || Number(value) > 100000) return null;

    return Number(value);
};
const newsPagePath = (category, page) => {
    const path = category && category !== 'tudo' ? `/noticias/${category}` : '/noticias';

    return page > 1 ? `${path}?page=${page}` : path;
};

module.exports = { PAGE_SIZE, parseNewsPage, newsPagePath };
